import PublicTeacherLegalDocsTable from "./PublicTeacherLegalDocsTable";

export default PublicTeacherLegalDocsTable